document.addEventListener('click', (e) => {
  const isMinus = e.target.closest('.quantity__minus');
  const isPlus = e.target.closest('.quantity__plus');

  if (isMinus || isPlus) {
    const wrapper = e.target.closest('.quantity-wrapper, quantity-counter');
    const input = wrapper?.querySelector('.quantity__input');

    if (input) {
      const value = parseInt(input.value, 10) || 1;

      document.querySelectorAll('.quantity__input').forEach((inp) => {
        inp.value = value;
        inp.dispatchEvent(new Event('change'));
      });
    }
  }
});
